import { render, staticRenderFns } from "./ModifyWordTablePopup.vue?vue&type=template&id=74204e4a&"
import script from "./ModifyWordTablePopup.vue?vue&type=script&lang=js&"
export * from "./ModifyWordTablePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports